import { Saga } from 'redux-saga'
import {
  all,
  put,
  call,
  takeLatest,
  ActionPattern,
  select,
} from 'redux-saga/effects'

import { secureSanitize } from '../../utils/sanitizeUtils'
import { actions, selectors } from '..'
import ApiSagas from '../api/sagas'
import { Recipes } from '../../graphql/Services'

export default class RecipesByTagSagas {
  static *init(context: any) {
    const {
      query: { page = 1, tag = '' },
    } = context

    const sanitizedTag = secureSanitize(tag, true)
    const sanitizedPage = secureSanitize(page)

    const pageNumber = parseInt(sanitizedPage, 10)

    yield put(actions.recipesByTag.setRecipesPage(pageNumber))
    yield put(actions.recipesByTag.setTag(sanitizedTag))

    return yield call(RecipesByTagSagas.onLoadRecipes, pageNumber, sanitizedTag)
  }

  static *loadRecipes(page: number, tag?: string) {
    const rs = yield call(
      ApiSagas.query,
      Recipes.queries.recipesByTag({
        themes: tag ? [tag] : [],
        first: 9,
        page: page || 1,
      })
    )
    yield put(actions.recipesByTag.setRecipesPage(page || 1))
    return rs
  }

  static *onLoadRecipes(page?: number, tag?: string) {
    const { data: res } = yield call(
      RecipesByTagSagas.loadRecipes,
      page || 1,
      tag
    )

    yield put(
      actions.recipesByTag.setHasMorePages(res?.paginatorInfo.hasMorePages)
    )
    yield put(actions.recipesByTag.setRecipes(res?.data))
    yield put(actions.recipesByTag.setLoadedPages([page || 1]))

    if (!res) {
      return { error: 404 }
    }
  }

  static *onLoadPreviousRecipes() {
    const loadedPages = yield select(selectors.recipesByTag.loadedPages)
    const lastPage = yield select(selectors.recipesByTag.firstLoadedPage)
    const tag = yield select(selectors.recipesByTag.tag)
    const page = lastPage - 1

    const { data: result } = yield call(
      RecipesByTagSagas.loadRecipes,
      page,
      tag
    )

    yield put(actions.recipesByTag.prependRecipes(result?.data))
    yield put(actions.recipesByTag.setLoadedPages(loadedPages.concat([page])))

    if (!result) {
      return { error: 404 }
    }
  }
  static *onLoadMoreRecipes() {
    const loadedPages = yield select(selectors.recipesByTag.loadedPages)
    const lastPage = yield select(selectors.recipesByTag.lastLoadedPage)
    const tag = yield select(selectors.recipesByTag.tag)
    const page = lastPage + 1

    const { data: result } = yield call(
      RecipesByTagSagas.loadRecipes,
      page,
      tag
    )

    yield put(
      actions.recipesByTag.setHasMorePages(result.paginatorInfo.hasMorePages)
    )
    yield put(actions.recipesByTag.appendRecipes(result?.data))
    yield put(actions.recipesByTag.setLoadedPages(loadedPages.concat([page])))

    if (!result) {
      return { error: 404 }
    }
  }

  static *loop() {
    yield all([
      takeLatest(
        actions.recipesByTag.loadMoreRecipesPage as ActionPattern,
        this.onLoadMoreRecipes as Saga
      ),
      takeLatest(
        actions.recipesByTag.loadPreviousRecipesPage as ActionPattern,
        this.onLoadPreviousRecipes as Saga
      ),
      takeLatest(
        actions.recipesByTag.loadRecipes as ActionPattern,
        this.onLoadRecipes as Saga
      ),
    ])
  }
}
